export default __webpack_public_path__ + "static/media/cameraIconTextEditor.1ebc5596.svg";